import { ThemeRadii } from '../ThemeRadii';
import { RadiiArray } from '../types';

export const generateRadii = (radiiValues: RadiiArray, namedValues: Record<ThemeRadii, number>) =>
  Object.assign([...radiiValues] as RadiiArray, namedValues);
